import {app} from './app'
import {createI18n} from 'vue-i18n'
import {createHead} from '@vueuse/head'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

import './registerServiceWorker'
import router from './router'
import iframeResize from 'iframe-resizer/js/iframeResizer';

import store from './store'

import {
    getAxiosInstance,
    getRouteInstance,
    getStoreInstance,
    initAxios, initI18n,
    initRouter,
    initStore
} from "@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance";

initAxios(store, router)
let axios = getAxiosInstance()

initStore(store)
let newStore = getStoreInstance()

initRouter(router)
let newRouter = getRouteInstance()

import ToastPlugin from 'vue-toast-notification';

app.use(ToastPlugin);
import './scss/custom.scss'

import 'bootstrap-icons/font/bootstrap-icons.css'

require('bootstrap')
import '@moeinmdn/mixitweb-front-modules/src/plugin/class/MainRequirementsV3'

const head = createHead()

app.directive('resize', {
    mounted(el) {
        iFrameResize({log: false}, el)
    },
})

// ..
AOS.init();


import {translations as fa} from './views/fa/Translation';  let messages = { ...fa, };


export const i18n = createI18n({
    locale: 'fa',
    fallbackLocale: 'fa',
    messages
})

initI18n(i18n)
newStore.dispatch("Authentication/attemptLogin").then(async (r) => {
    await newStore.dispatch('SiteServiceManager/isProjectExpire')
    await newStore.dispatch("Language/getLanguages");
    await newStore.dispatch('SiteInfo/getSiteInfos')
    if (await newStore.getters['User/isAuthenticated']) {
        await newStore.dispatch("ShoppingCart/userOrderUnpaid");
    }
    app.use(newStore).use(head).use(i18n).use(newRouter).mount('#app')
})
    .catch(async(err) => {
        await newStore.dispatch("Language/getLanguages");
        await newStore.dispatch('SiteInfo/getSiteInfos')
        app.use(newStore).use(head).use(i18n).use(newRouter).mount('#app')
    })
